<!--Menu Options-->
<div class="val-CenterText val-FitWidth val-MenuBarItem">
	<!--School Select-->
	<div class="val-Flex val-FitWidth">
		<label class="val-FlexItem">School:</label>
		<!-- <select  class="form-control val-FlexItem" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="valData.SchoolID">
            <option value="" style="display:none;"></option>
            <option *ngFor="let o of SchoolList" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
        </select> -->

		<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
	</div>

	<!--Options Grid-->
	<div class="val-Grid2ColMain val-LeftText val-FitWidth val-TopMargin">
		<!--Left column, date/time/application/module-->
		<div class="val-Grid2Row val-Spacing val-FitWidth">
			<!--2 Row Grid-->

			<!--Date and time-->
			<div class="val-Grid4ColNormal">
				<label>Start Date:</label>
				<p-calendar [disabled]="loading" showIcon="true" showButtonBar="true" [(ngModel)]="valData.StartDate" name="StartDate"></p-calendar>

				<label>Start Time:</label>
				<p-calendar
					[disabled]="loading"
					showIcon="true"
					showButtonBar="true"
					showTime="true"
					hourFormat="12"
					timeOnly="true"
					[(ngModel)]="valData.StartTime"
					name="StartTime"
				></p-calendar>

				<label>End Date:</label>
				<p-calendar [disabled]="loading" showIcon="true" showButtonBar="true" [(ngModel)]="valData.EndDate" name="EndDate"></p-calendar>

				<label>End Time:</label>
				<p-calendar
					[disabled]="loading"
					showIcon="true"
					showButtonBar="true"
					showTime="true"
					hourFormat="12"
					timeOnly="true"
					[(ngModel)]="valData.EndTime"
					name="EndTime"
				></p-calendar>
			</div>

			<!--Application and module-->
			<div class="val-Grid2ColSplit">
				<label>Application:</label>
				<select
					[disabled]="loading"
					class="form-control"
					name="ApplicationKey"
					(ngModelChange)="onApplicationKeyChange($event)"
					[(ngModel)]="valData.ApplicationKey"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of applicationForLogList" [ngValue]="o.ApplicationKey">
						{{ o.ApplicationName }}
					</option>
				</select>

				<label>Module:</label>
				<select [disabled]="loading" class="form-control" name="ModuleName" [(ngModel)]="valData.ModuleName">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of moduleList" [ngValue]="o.ModuleName">
						{{ o.ModuleName }}
					</option>
				</select>
			</div>
		</div>
		<!--Right column filter checkboxes-->
		<div class="val-FitWidth">
			<label>Filter Message Types:</label>
			<div class="val-Grid2ColNormal">
				<label for="NormalMessage">Normal Message (N):</label>
				<input [disabled]="loading" id="NormalMessage" [(ngModel)]="valData.NormalMessage" type="checkbox" />

				<label for="ProcessStart">Process Start (S):</label>
				<input [disabled]="loading" id="ProcessStart" [(ngModel)]="valData.ProcessStart" type="checkbox" />

				<label for="ProcessComplete">Process Complete (T):</label>
				<input [disabled]="loading" id="ProcessComplete" [(ngModel)]="valData.ProcessComplete" type="checkbox" />

				<label for="HandledError">Handled Error (E):</label>
				<input [disabled]="loading" id="HandledError" [(ngModel)]="valData.HandledError" type="checkbox" />

				<label for="CriticalError">Critical Error (C):</label>
				<input [disabled]="loading" id="CriticalError" [(ngModel)]="valData.CriticalError" type="checkbox" />
			</div>
		</div>
	</div>

	<!--Search Button-->
	<button class="btn btn-primary val-TopMargin" (click)="SearchLogs()">Search</button>
</div>

<!--Table-->
<div class="val-MenuBarItem val-TopMargin">
	<!--P Table-->
	<p-table
		[value]="logs"
		[loading]="loading"
		selectionMode="single"
		[(selection)]="valData.SelectedLog"
		dataKey="ApplicationLogID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		[paginator]="true"
		[rows]="15"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 15, 25, 50]"
		sortMode="multiple"
		id="dt"
	>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="DateAndTime">Date and Time<p-sortIcon field="DateAndTime"></p-sortIcon></th>
				<th pSortableColumn="Type">Type<p-sortIcon field="Type"></p-sortIcon></th>
				<th pSortableColumn="ModuleName">Module Name<p-sortIcon field="ModuleName"></p-sortIcon></th>
				<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th pSortableColumn="UserName">User Name<p-sortIcon field="UserName"></p-sortIcon></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-log>
			<tr [pSelectableRow]="log" (dblclick)="onRowDblClick(log)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ log[col.field] }}
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="paginatorleft">
			<p-button type="button" icon="pi" styleClass="p-button-text"></p-button>
		</ng-template>
		<ng-template pTemplate="paginatorright">
			<p-button type="button" icon="pi" styleClass="p-button-text"></p-button>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="val-CenterText val-TopMargin">
	<button class="btn btn-primary" (click)="onViewLog()">View Log</button>
</div>

<!--Error Message-->
<div class="form-group val-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
